var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Button from "@/components/Button";
import Input from "@/components/Form/Input";
import { Link } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import toast from "react-hot-toast";
import { useState } from "react";
export default function Login() {
    var _this = this;
    var _a = useAuth(), login = _a.login, loginWithCognito = _a.loginWithCognito;
    var _b = useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var handleSubmit = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var toastID, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    toastID = toast.loading("Logging in...");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, login(e.currentTarget.username.value, e.currentTarget.password.value)];
                case 2:
                    _a.sent();
                    toast.success("Login success", { id: toastID });
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    toast.error(err_1.message, { id: toastID });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleCognitoLogin = function () { return __awaiter(_this, void 0, void 0, function () {
        var toastID, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    toastID = toast.loading("Redirecting to Cognito...");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, loginWithCognito()];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    err_2 = _a.sent();
                    toast.error(err_2.message, { id: toastID });
                    setIsLoading(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "flex flex-col gap-6 px-4 sm:gap-8 sm:px-8 lg:px-14", children: [_jsxs("div", { className: "flex flex-col gap-2", children: [_jsx("h1", { className: "text-xl", children: "Welcome back!" }), _jsx("p", { className: "text-xs font-medium text-[#858585]", children: "Sign in to your account" })] }), _jsxs("form", { onSubmit: handleSubmit, className: "flex flex-col gap-4", children: [_jsx(Input, { label: "Email / Phone", name: "username", required: true }), _jsx(Input, { label: "Password", name: "password", type: "password", required: true }), _jsx(Link, { to: "/auth/forgot-password", className: "text-right text-xs font-medium text-[#008AE6]", children: "Forgot password?" }), _jsx(Button, { type: "submit", children: "Sign In" })] }), _jsxs("div", { className: "flex items-center gap-4", children: [_jsx("div", { className: "h-px flex-1 bg-gray-300" }), _jsx("span", { className: "text-xs text-[#858585]", children: "OR" }), _jsx("div", { className: "h-px flex-1 bg-gray-300" })] }), _jsx(Button, { type: "button", onClick: handleCognitoLogin, disabled: isLoading, className: "mt-2 rounded-[5rem] border-2 border-[#1BC5BD] bg-white py-4 text-xs font-semibold text-[#1BC5BD] hover:bg-gray-50", children: "Sign in with Beep Account" })] }), _jsxs("p", { className: "my-6 px-4 text-center text-xs font-medium text-[#858585] sm:my-8 sm:px-8", children: ["Don't have an account?", " ", _jsx("a", { href: "/register", className: "text-[#1BC5BD]", children: "Sign up" })] }), _jsx("p", { className: "px-4 text-center text-xs font-medium text-[#B5B5C3] sm:px-8", children: "By logging in, you agree to our Terms and Conditions & Privacy Policy" })] }));
}
